<template>
  <div class="jp-common-layout ">
    <div class="jp-common-layout-left" style="width: 370px;">
      <div class="jp-common-title flexTreeTitle"> 
          <el-input
            placeholder="请输入关键字进行过滤"
            style="width: 245px;"
            size="small"
            clearable
            v-model="filterText">
          </el-input>
          <div>
            <el-button @click="searchTree('search')" size="small" type="primary" circle   icon="el-icon-search"></el-button>
            <el-button @click="searchTree('expandAll')" size="small" type="primary" circle   icon="fa fa-random"></el-button>
          </div>
        </div>
        <div class="jp-common-el-tree-scrollbar el-scrollbar">
          <div class="el-scrollbar__wrap" :style="{height: treeHeight-40 +'px',marginTop: '20px'}">
            <div class="el-scrollbar__view" style="">
                <vxe-table
                  show-overflow
                  border="none"
                  ref="xTree"
                  :height="treeHeight-40+'px'"
                  :loading="loadingTree"
                  :show-header="false"
                  :tree-config="{transform: true, rowField: 'id', parentField: 'parentIdNew',expandAll: treeExpandAll,reserve:true}"
                  :radio-config="{labelField: 'nameCn'}"
                  :row-config="{keyField:'id',isCurrent: true, isHover: true}"
                  :data="showTreeList">
                  <vxe-column field="nameCn"   tree-node>
                    <template slot-scope="scope">
                      <div class="treeSpan" @click="handRow(scope.row)">{{ scope.row.name }}</div>
                    </template>
                  </vxe-column>
                </vxe-table>
            </div>
          </div>
        </div>
    </div>
    <div class="jp-common-layout-center jp-flex-main">
    <div class="page">
      <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
            <el-form-item prop="nameCnEe">
              <el-input size="small" v-model="searchForm.nameCnEe" placeholder="中/英名称" clearable></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input size="small" v-model="searchForm.code" placeholder="物品编码" clearable></el-input>
            </el-form-item>
            <el-form-item prop="cascaderValue">
              <el-cascader
                v-model="searchForm.cascaderValue"
                :options="categoryTree"
                :props="{ multiple: false, checkStrictly: true }"
                @change="handCascader"
                clearable></el-cascader>
            </el-form-item>
            <el-form-item prop="itemPeroperty">
              <el-select
                  v-model="searchForm.itemPeroperty"
                  clearable
                  placeholder="属性"
                  style="width: 180px"
                >
                  <el-option
                    v-for="item in $dictUtils.getDictList('cec_item_property')"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
              <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>

     <div class="bg-white top">
        <vxe-toolbar>
          <template #buttons>
            <!-- <el-button v-if="hasPermission('cecitem:cecItem:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button> -->
            <!-- <el-button v-if="hasPermission('cecitem:cecItem:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecItemTable && $refs.cecItemTable.getCheckboxRecords().length !== 1" plain>修改</el-button> -->
            <!-- <el-button v-if="hasPermission('cecitem:cecItem:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecItemTable && $refs.cecItemTable.getCheckboxRecords().length === 0" plain>删除</el-button> -->
            <el-button v-if="hasPermission('cecitem:cecItem:getCec')" @click="getCecItem()" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC材料数据</el-button>
            <el-button v-if="hasPermission('cecitem:cecItem:getCec')" @click="getCecitemagilefield()" size="small" type="success" icon="el-icon-refresh-right" :loading="loading">获取CEC材料扩展数据</el-button>
          </template>
        </vxe-toolbar>
        <div style="height: calc(100% - 80px);">
        <vxe-table
            border="full"
            auto-resize
            resizable
            height="auto"
            :loading="loading"
            size="small"
            ref="cecItemTable"
            show-header-overflow
            show-overflow
            highlight-hover-row
            :menu-config="{}"
            :print-config="{}"
            :import-config="{
            importMethod: importMethod,
                types: ['csv', 'xls', 'xlsx'],
                remote: true,
            }"
            :export-config="{
                remote: true,
                filename: `材料表数据${moment(new Date()).format(
            		'YYYY-MM-DD'
                )}`,
                sheetName: '材料表数据',
                exportMethod: exportMethod,
                types: ['xlsx'],
                modes: ['current', 'selected', 'all'],
            }"
            :expand-config="{accordion: true, lazy: true, loadMethod: loadContentMethod}"
            @sort-change="sortChangeHandle"
            :sort-config="{remote:true}"
            :data="dataList"
            :checkbox-config="{}">
            <vxe-column type="seq"  align="center" width="50"  title="序号"></vxe-column>
            <vxe-column type="expand" width="50"  title="展开">
              <template #content="{ row }">
                <div style="padding: 10px;">
                  <vxe-table
                    border="full"
                    auto-resize
                    resizable
                    :loading="loading"
                    size="small"
                    ref="cecItemTable2"
                    show-header-overflow
                    show-overflow
                    highlight-hover-row 
                    :data="row.childData">
                    <vxe-column type="seq"  align="center" width="50"  title="序号"></vxe-column>
                    <vxe-column
                      field="code"
                      align="center"
                      width="150"
                      sortable
                      title="编码">
                      <template slot-scope="scope">
                        <el-link  type="primary" :underline="false" v-if="hasPermission('cecitem:cecItem:view')"  @click="view(scope.row)">{{scope.row.code}}</el-link>
                        <span v-else>{{scope.row.code}}</span>
                      </template>
                    </vxe-column>
                    <vxe-column
                      field="name"
                      align="center"
                      width="200"
                      sortable
                      title="英文名称">
                    </vxe-column>
                    <vxe-column
                      field="nameCn"
                      align="center"
                      width="200"
                      sortable
                      title="中文名称">
                    </vxe-column>
                    <vxe-column
                      field="category.name"
                      align="center"
                      width="200"
                      sortable
                      title="分类">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.category.parentIdsName" placement="top">
                          <div class="textOverflow">{{ scope.row.category.name }}</div>
                        </el-tooltip>
                      </template>
                    </vxe-column>
                    <vxe-column
                      field="itemPeroperty"
                      align="center"
                      width="80"
                      sortable
                      title="属性">
                      <template slot-scope="scope">
                        {{ setItemPeropertyText(scope.row.itemPeroperty) }}
                      </template>
                    </vxe-column>
                    <vxe-column
                      field="price"
                      align="center"
                      width="80"
                      sortable
                      title="单价">
                      <template slot-scope="scope">
                          <div class="flexBetween">
                            <span>$</span>
                            <span>{{  $mathUtil.mathToFixed(scope.row.price) }}</span>
                          </div>
                        </template>
                    </vxe-column>
                    <vxe-column
                      field="unit"
                      align="center"
                      width="80"
                      sortable
                      title="单位">
                      <template slot-scope="scope">
                        {{ scope.row.units.unitEn }}
                      </template>
                    </vxe-column>
                  <!-- <vxe-column
                      field="variateRemarks"
                      align="center"
                      width="200"
                      sortable
                      title="规格">
                    </vxe-column> -->
                    <vxe-column
                      field="description"
                      align="center"
                      title="描述">
                    </vxe-column>
                  </vxe-table>
                </div>
              </template>
          </vxe-column>
      <vxe-column
        field="code"
        align="center"
        width="80"
        sortable
        title="编码">
        <template slot-scope="scope">
          <el-link  type="primary" :underline="false" v-if="hasPermission('cecitem:cecItem:view')"  @click="view(scope.row)">{{scope.row.code}}</el-link>
          <span v-else>{{scope.row.code}}</span>
        </template>
      </vxe-column>
      <vxe-column
        field="name"
        align="center"
        min-width="200"
        sortable
        title="英文名称">
        <template slot-scope="scope">
          {{ scope.row.parentId == '0' && scope.row.mainItemId ? scope.row.mainItemName :  scope.row.name}}
        </template>
      </vxe-column>
      <vxe-column
        field="nameCn"
        align="center"
        min-width="200"
        sortable
        title="中文名称">
        <template slot-scope="scope">
          {{ scope.row.parentId == '0' && scope.row.mainItemId ? scope.row.mainItemNameCn :  scope.row.nameCn}}
        </template>
      </vxe-column>
      <vxe-column
        field="category.name"
        align="center"
        width="200"
        sortable
        title="分类">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.category.parentIdsName" placement="top">
            <div class="textOverflow">{{ scope.row.category.name }}</div>
          </el-tooltip>
        </template>
      </vxe-column>
      <vxe-column
        field="itemPeroperty"
        align="center"
        width="80"
        sortable
        title="属性">
        <template slot-scope="scope">
          {{ setItemPeropertyText(scope.row.itemPeroperty) }}
        </template>
      </vxe-column>
      <vxe-column
        field="price"
        align="center"
        width="80"
        sortable
        title="单价">
        <template slot-scope="scope">
            <div class="flexBetween">
              <span>$</span>
              <span>{{  $mathUtil.mathToFixed(scope.row.price) }}</span>
            </div>
          </template>
      </vxe-column>
      <vxe-column
        field="unit"
        align="center"
        width="80"
        sortable
        title="单位">
        <template slot-scope="scope">
          {{ scope.row.units.unitEn }}
        </template>
      </vxe-column>
    <!-- <vxe-column
        field="variateRemarks"
        align="center"
        width="200"
        sortable
        title="规格">
      </vxe-column> -->
      <vxe-column
        field="description"
        align="center"
        min-width="100"
        title="描述">
      </vxe-column>
    </vxe-table>
    <vxe-pager
      background
      size="small"
      :current-page="tablePage.currentPage"
      :page-size="tablePage.pageSize"
      :total="tablePage.total"
      :page-sizes="[10, 20, 100, 1000, {label: '全量数据', value: 1000000}]"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="currentChangeHandle">
    </vxe-pager>
    </div>
    </div>
        <!-- 弹窗, 新增 / 修改 -->
    <CecItemForm  ref="cecItemForm" @refreshDataList="refreshList"></CecItemForm>
  </div>
</div>
</div>
</template>

<script>
  import CecItemForm from './CecItemForm'
  import cecItemService from '@/api/cecitem/cecItemService'
  import cecItemCategoryService from '@/api/cecitemcategory/cecItemCategoryService'
  import cecItemFieldService from '@/api/cecitemfield/cecItemFieldService'
  import cecItemAgileFieldService from '@/api/cecitemagilefield/cecItemAgileFieldService'
  export default {
    data () {
      return {
        searchForm: {
          nameCnEe: '',
          categoryId: '',
          parentIdLike: '',
          parentId: '0',
          cascaderValue: [],
          itemPeroperty: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          orders: [{ column: 'a.create_date', asc: false }]
        },
        loading: false,
        loadingTree: false,
        itemPeropertyList: [],
        filterText: '',
        officeTreeData: [],
        showTreeList: [],
        treeHeight: '',
        treeExpandAll: false,
        categoryTree: [],
        parentCode: ''
      }
    },
    components: {
      CecItemForm
    },
    activated () {
      this.refreshList()
      this.getItemCategoryList()
      this.itemPeropertyList = this.$dictUtils.getDictList('cec_item_property')
      this.treeHeight = document.getElementsByClassName('jp-common-el-tree-scrollbar')[0].offsetHeight
    },
    methods: {
      handCascader (e) {
        if (e.length > 0) {
          let findDate = this.officeTreeData.find(item => item.id === e[e.length - 1])
          if (findDate.children.length > 0) {
            this.searchForm.parentIdLike = findDate.id
            this.searchForm.categoryId = ''
          } else {
            this.searchForm.parentIdLike = ''
            this.searchForm.categoryId = findDate.id
          }
        } else {
          this.searchForm.parentIdLike = ''
          this.searchForm.categoryId = ''
        }
      },
      // 子表单
      loadContentMethod ({ row }) {
        this.loading = true
        this.parentCode = row.code
        return new Promise(resolve => {
          setTimeout(() => {
            cecItemService.parentList({
              parentId: row.id
            }).then((res) => {
              row.childData = res.data
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
            resolve()
          }, 500)
        })
      },
      // 点击树结构
      async handRow (row) {
        this.searchForm.parentIdLike = row.id
        if (row.children.length > 0) {
          this.searchForm.parentIdLike = row.id
          this.searchForm.categoryId = ''
        } else {
          this.searchForm.parentIdLike = ''
          this.searchForm.categoryId = row.id
        }
        let splitArray = row.parentIds.split(',')
        splitArray.push(row.id)
        this.searchForm.cascaderValue = splitArray.filter(item => item !== '0' && item !== '')
        this.refreshList()
      },
      // 展开和搜索树结构
      searchTree (type) {
        if (type === 'expandAll') {
          this.treeExpandAll = !this.treeExpandAll
          this.$refs.xTree.setAllTreeExpand(this.treeExpandAll)
        } else if (type === 'search') {
          let parentList = []
          this.loadingTree = true
          if (this.filterText) {
            let filerData = this.officeTreeData.filter(item => item.name.indexOf(this.filterText) >= 0)
            filerData.forEach(item => {
              let findDate = this.officeTreeData.find(fitem => fitem.id === item.parentId)
              if (findDate) {
                parentList.push(findDate)
              }
            })
            let filterList = [...filerData, ...parentList]
            this.showTreeList = filterList
            this.$refs.xTree.setAllTreeExpand(true)
            this.loadingTree = false
          } else {
            this.showTreeList = this.officeTreeData
            this.loadingTree = false
          }
        }
      },
      // 获取物品类型列表
      getItemCategoryList () {
        this.loading = true
        this.loadingTree = true
        cecItemCategoryService.allList({
        }).then(({data}) => {
          this.officeTreeData = data
          this.showTreeList = data
          let mapList = data.map(item => {
            let citem = {
              value: item.id,
              label: item.name,
              id: item.id,
              parentIdNew: item.parentIdNew
            }
            return citem
          })
          this.categoryTree = this.setTree(mapList)
          this.loading = false
          this.loadingTree = false
        })
      },
      setTree (data, parentId = '0') {
        // 创建一个空数组来存储树节点
        const tree = []
        // 遍历数组对象
        data.forEach(item => {
          // 判断当前项的parentId是否与传入的parentId匹配
          if (item.parentIdNew === parentId) {
            // 递归调用generateTree方法，获取当前项的子节点
            const children = this.setTree(data, item.id)
            // 如果当前项有子节点，则将它们添加到children数组中
            if (children.length > 0) {
              item.children = children
            }
            // 将当前项添加到树节点数组中
            tree.push(item)
          }
        })
        return tree
      },
      setItemPeropertyText (value) {
        if (!value) return
        let itemPeropertyList = value.split(',')
        let mapArray = itemPeropertyList.map(item => {
          let findDate = this.itemPeropertyList.find(fitem => fitem.value === item)
          return findDate ? findDate.label : ''
        })
        return mapArray.join(',')
      },
      // 获取cec套餐项目表数据
      getCecItem () {
        this.loading = true
        cecItemService.getCecUpdateItem({}).then(({res}) => {
          this.$message.success('获取成功')
          this.refreshList()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      getCecItemExtension () {
        this.loading = true
        cecItemFieldService.getCecitemUpdatePosition({}).then(({res}) => {
          // this.loading = false
          this.$message.success('获取成功')
          this.getCecitemagilefield()
        }).catch(() => {
          this.loading = false
        })
      },
      getCecitemagilefield () {
        this.loading = true
        cecItemAgileFieldService.getCecItemAgileField({}).then(({res}) => {
          this.$message.success('获取成功')
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecItemService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records.map(item => {
            if (!item.jsonStr) {
              item.JsonList = []
              return item
            }
            let jsonObj = JSON.parse(item.jsonStr)
            // 转换后的数组
            const resultArray = []
            // 遍历JSON对象的每个键值对
            for (const key in jsonObj) {
              if (jsonObj.hasOwnProperty(key)) {
                // 将当前对象的键转换为id，并添加到新对象中
                const newObj = { ...jsonObj[key], id: key }
                // 将新对象添加到数组中
                resultArray.push(newObj)
              }
            }
            item.JsonList = resultArray
            return item
          })
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecItemForm.init('add', '')
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecItemTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecItemForm.init('edit', id)
      },
      // 查看
      view (data) {
        let query = {
          id: data.id,
          parentCode: data.parentId === '0' ? '' : this.parentCode
        }
        this.$refs.cecItemForm.init('view', query)
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecItemTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecItemService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecItemService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecItemService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecItemService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.searchForm.cascaderValue = ''
        this.refreshList()
      }
    }
  }
</script>
<style scoped>
.flexTreeTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-scrollbar__view  .vxe-body--row.row--current {
    background-color: #ffd991 !important;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .jp-common-layout-left .vxe-body--column{
  height: 35px !important;
}
.treeSpan {
  height: 35px;
  width: 100%;
  line-height: 35px;
  cursor: pointer;
}
.textOverflow{
  overflow: hidden;
  text-overflow: ellipsis;
}
.flexBetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

